import { useNavigate} from "react-router";
import {useDispatch} from 'react-redux';
import {useMemo,useEffect,useState,useRef } from 'react'
import {useGetOrgInfoQuery,useGetProcessInstancesQuery,useCreateProcessStateEntryMutation,useGetFormListQuery,
		useCreateProcessInstanceMutation,useGetActiveStatesQuery,useLoadUserQuery} from './redux/databaseView';
import {advanceState} from './stateTraversal'
import CommandIntercept from './CommandIntercept'
import {SimpleDialog} from './CommandIntercept.js'
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Stack,CircularProgress } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {getAccess} from './App'
const defaultWarnings={approaching:{name:"Deadline approaching", color: 'orange', days: 7},
					overdue:{name:"Overdue task", color: 'red', days: 2},
					stale: {name:"Stale task", color: 'yellow', days: 4}};



const formatDate = (value) => {
    if (!value) return '';
//	console.log("due formatter", value);
    return new Date(value).toLocaleDateString('en-AU', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    });
};

const TaskGridColDef = [
//  { field: 'nid', headerName: 'ID', width: 70 },
  { field: 'typeID', headerName: 'Task ID', width: 140, cellClassName: 'task-id-cell' },
  { field: 'descriptor', headerName: 'Process', width: 260 },
  { field: 'description', headerName: 'Activity', width: 260 },
  { field: 'time', headerName: 'Waiting since', width: 130,valueFormatter:formatDate},
  { field: 'due', headerName: 'Due Date', width: 130,valueFormatter:formatDate },
  { field: 'owner', headerName: 'Owner', width: 130 },
];


const ProcessGridColDef = [
  { field: 'nid', headerName: 'ID', width: 70 },
  { field: 'typeID', headerName: 'SubID', width: 140 },
  { field: 'descriptor', headerName: 'Process', width: 260 },
  { field: 'descriptions', headerName: 'Current State(s)', width: 260 },
  { field: 'created', headerName: 'Start Date', width: 130 },
  { field: 'due', headerName: 'Due Date', width: 130 },
  { field: 'owners', headerName: 'Owner(s)', width: 130 },
];

	
function ensureFourDigits(num) {
  return String(num).padStart(4, '0');
}


export function Dashboard() {
	const {isFetching,data:orgData}=useGetOrgInfoQuery()
	const viewOptions=["Tasks","Processes"];
	const statusOptions=["Open only","All"];
	const filterOptions=["Own","Direct Reports","My Organisation"];
	const navigate=useNavigate();
	const dispatch=useDispatch();
	const [dlgOpen, setOpen] = useState(false);
	const [addProcessStateEntry]=useCreateProcessStateEntryMutation();
	const [createProcessInstance]=useCreateProcessInstanceMutation();
	const initialFilter={status:statusOptions[0],viewType:viewOptions[0],processType:"No filter",filterMode:filterOptions[0]};
	const [filter,setFilter]=useState(initialFilter);
	const [loadedSettings,setLoadedSettings]=useState(0);
//	console.log(filter);
	const userList=useLoadUserQuery();
	const  data=useGetActiveStatesQuery({filterMode:filter?.filterMode, onFailure: 1, processType:filter?.processType!=="No filter"?filter?.processType:null,activeOnly:(filter?.status===statusOptions[0])},{ refetchOnMountOrArgChange: true, skip:!loadedSettings });
//	const data=useGetActiveStatesQuery({filterMode:filter?.filterMode, processType:filter?.processType!="No filter"?filter?.processType:null,activeOnly:(filter?.status==statusOptions[0])});
	const instanceData=useGetProcessInstancesQuery({showClosed:false,extraUser:[],processType:filter.processType!=="No filter"?filter.processType:null});		//processType is set or null
	const { data: processTypeData, isLoading:ptIsLoading }=useGetFormListQuery({type:"diagram",active:true,onFailure:1});
//	console.log(loadedSettings,filter);
	function DBSelect({label,options, value,onChange})
	{
	function changeValue(value)
		{
		setFilterOptions(onChange,value);
		}
	
	return (
	<FormControl  size="small" sx={{ minWidth: 180}}>
        <FormLabel sx={{textAlign:'left'}} htmlFor="supervisor">{label}</FormLabel>
	    <Select
			size="small"
			labelId="demo-simple-select-label"
			id="demo-simple-select"
			value={value}
			onChange={(e)=>changeValue(e.target.value)}
		  >
		  {options.map((x,idx)=>{
			return (<MenuItem value={x}>{x}</MenuItem>)
			})
			}
		</Select>
	</FormControl>);
	}


	useEffect(()=>{
		async function loadFilter()
			{
			var revFilter=await localStorage.getItem('dashboardFilter');
			try {
				revFilter=JSON.parse(revFilter);
				if (revFilter!=null)
					await setFilter(revFilter);
				}
			catch (e)
				{
				console.error(e);
				}
//			console.log(filter);
			setLoadedSettings(1);
			}
		loadFilter();
		return ()=>{};
		},[]);
	async function setFilterOptions(option,value)
		{
		var revFilter={...filter};
		revFilter[option]=value;
		localStorage.setItem('dashboardFilter',JSON.stringify(revFilter));
		setFilter(revFilter);
		}
	const warnings=useMemo(()=>{
		if (isFetching)
			{
			return defaultWarnings;
			}
		var siteSettings=orgData?.data?.siteSettings?JSON.parse(orgData.data.siteSettings):null;
		if (siteSettings===null)
			return defaultWarnings;
		var obj={};
		siteSettings?.warnings?.forEach((x)=>{
			if (x.name==="Deadline approaching")
				obj.approaching=x;
			else if (x.name==="Overdue task")
				obj.overdue=x;
			else if (x.name==="Stale task")
				obj.stale=x;
			else
				console.error("unknown item "+x.name);
			});
//		console.log(obj);
		return obj;
		},[isFetching,orgData]);
	const indexedUser=useMemo(()=>{
		var iu={};
		if (!userList.isSuccess)
			return {};
		else
			userList.data.data.forEach((x)=>
				{
				iu[x.id]=x.displayName?x.displayName:x.name;
				});
		return iu;
		},[userList.isSuccess,userList?.data?.data]);

	const containerRef = useRef(null);	//console.log(JSON.stringify(data));
	const type="diagram";
	function addNew()
		{
		setOpen(true);
		};

	async function handleClose(processID)
		{
		if (processID)
			{
//			console.log(processID);
			const result=await createProcessInstance({id:processID.formid,prefix:processID.prefix});
//			console.log(result);
			const instanceInfo=result.data;
//			console.log(instanceInfo);
			if (instanceInfo.success)
				{
				var processState={
					processId:processID.formid,
					moddle:processID.moddle,
					stateOwnerTable:processID.stateOwnerTable
					};

				var futureStates=await advanceState(
					dispatch,
					processState,
					instanceInfo.data,
					null,
					null,
					addProcessStateEntry,
					{}
					);
				console.log(futureStates);
				
				var state=null;

				for (var x of futureStates)
					{
					var access=await getAccess({
						instance:instanceInfo.data,
						state:x.id
						});

					if (access)
						{
						state=x;
						break;
						}
					}
				if (state)
					navigate("/data/"+instanceInfo.data+"/"+state.id);
				else
					navigate("/?alternateTeam=1");			
				}
			}
		setOpen(false);
		}
	async function selectRow(data)
		{
//		if (filter.viewType==="Tasks")
			navigate("/data/"+data.row.nid+"/"+data.row.state);
		}
		
//	console.log(data);
	var dataT=useMemo(()=>
		{
//		console.log("recalc",data,instanceData);
		var dataT=[];
		if (!userList.isSuccess)
			return dataT
		if (data.isSuccess&&(filter.viewType==="Tasks"))
			{
//			console.log("inside");
			if (!data.data.success)
				return [];
			var conversionTable={};
			data.data.data.forEach((x,idx)=>{
				var revData={...x,id:idx,nid:x.instance};
				if (indexedUser[revData.assignedUser])
					revData.staffName=indexedUser[revData.assignedUser];
				//console.loo
				revData.typeID=revData.prefix+ensureFourDigits(revData.typeID);
				conversionTable[x.instance]=revData.typeID;
				if (revData.owner==="_initiator")
					revData.owner=revData.staffName;
				else if (revData.staffName)
					revData.owner=revData.staffName+" ("+revData.owner+")";
				dataT.push(revData);				
				});
//			dispatch(setConversionTable(conversionTable));
//			console.log(dataT);
			}
		else if (instanceData.isSuccess&&(filter.viewType==="Processes"))
			{
//			console.log(indexedUser);
			instanceData.data.data.forEach((x,idx)=>{
				var revData={...x,id:idx,nid:x.id};
				if (indexedUser[revData.staff])
					revData.staff=indexedUser[revData.staff];
				revData.typeID=revData.prefix+ensureFourDigits(revData.typeID);
//				console.log(revData);
				if (revData.owners.includes("_initiator"))
					{
					revData.owners=revData.owners.replace("_initiator",indexedUser[revData.author]);
					}
				dataT.push(revData);
				});
			}
		
		return dataT;
		},[data.data?.data,
			data.data?.success, 
			instanceData.data?.data,
			userList.isSuccess,
			data.isSuccess,
			filter.viewType,
			indexedUser,
			instanceData.isSuccess])

	const columns=(filter.viewType==="Tasks")?TaskGridColDef:ProcessGridColDef;
	const processTypes=useMemo(()=>{
		var result=["No filter"];
		if (ptIsLoading)
			return result;
		if (!processTypeData?.data)
			return result;
		processTypeData.data.forEach((x)=>{
			result.push(x.formid)
			});
		return result;
		},[ptIsLoading,processTypeData?.data]);
//	console.log(processTypes);
	return (	
	<div  ref={containerRef} style={{overflow:"hidden",
		width:'100%',
		display:'flex',
//		backgroundColor:'yellow',
		flexDirection:'column',
		flex:1,
		minHeight:0,
        paddingLeft: '16px',
        paddingRight: '16px',
        boxSizing: 'border-box'}}>
	<CommandIntercept  getType={()=>"diagram"}/>
	<SimpleDialog
		selectedValue="none"
		open={dlgOpen}
		action="start"
		onClose={handleClose}
		type={type}
		title="Select process to start"
		/>
		
	  <Stack sx={{ px: 0,py:1 }}  direction="row" spacing={2}>
		<DBSelect label={"Show"} onChange={"filterMode"} options={filterOptions} value={filter.filterMode}/>
		<DBSelect label={"View Type"} onChange={"viewType"} options={viewOptions} value={filter.viewType}/>
		<DBSelect label={"Process"} onChange={"processType"} options={processTypes} value={filter.processType} />
		<DBSelect label={"Status"} onChange={"status"} options={statusOptions} value={filter.status} />
	  </Stack> 
	  <Box sx={{ display: 'flex', alignItems: 'center' }}>
		<Button variant="outlined" onClick={addNew}>
			Start Process
		</Button>
		<Box sx={{ flex: 1 }} />
		{/* future actions here */}
	  </Box>
	  {data.isLoading ? (
		  <Box
			sx={{
			  flex: 1,
			  display: 'flex',
			  alignItems: 'center',
			  justifyContent: 'center'
			}}
		  >
			<CircularProgress />
		  </Box>
		) : (
      <DataGrid
		pagination={false}
		hideFooter
        rows={dataT}
		getRowClassName={(params) => {
			const today = new Date();
			//console.log(params);
			const mstoday = today.getTime();


			if (params.row.due)
				{
				const dateString=params.row.due+"T23:59:00";
				const rowDate = new Date(dateString);			
				const msrow = rowDate.getTime();
				const daysDifference=(msrow-mstoday)/1000/3600/24; //->s -> hours -> days
//				console.log("days Difference", daysDifference);
				if (daysDifference<warnings.overdue.days)
					return "expired-row";
				if (daysDifference<warnings.approaching.days)
					return "approaching-row";
				}
			//if (
			if (params.row.time)
				{
				const startDate= new Date(params.row.time);
				const msstart=startDate.getTime();
				
				const daysSinceStart=(mstoday-msstart)/1000/3600/24;
//				console.log("since start", daysSinceStart);
				if (daysSinceStart>warnings.stale.days)
					return "stale-row";
				}
			return "";
//			console.log(rowDate,today,rowDate<today);
			//return (rowDate<today)?"expired-row":"";
			//const rowDate = new Date(params.row.dueDate);
			//return rowDate < today ? "expired-row" : "";
			}}
        columns={columns}
 		onRowClick={(params)=>selectRow(params)}
        sx={{ 
//			border: '2px solid red', 
			border: 0,
			flex: 1,
			minHeight:0,
			"& .expired-row > .task-id-cell": {
				backgroundColor: warnings.overdue.color, // light red
				color: "black",
				fontWeight: "bold",
				"&::before": {
					content: '"⚠"',
					marginRight: "6px",
					},	
				},
			"& .stale-row > .task-id-cell": {
				backgroundColor: warnings.stale.color, // light yellow
				color: "black",
				fontWeight: "bold",
				"&::before": {
					content: '"⌛"',
					marginRight: "6px",
					},	
				},
			"& .approaching-row > .task-id-cell": {
				backgroundColor: warnings.approaching.color, // light orange
				color: "black",
				fontWeight: "bold",
				"&::before": {
					content: '"◷"',
					marginRight: "6px",
					},	
				},
			'& .MuiDataGrid-cell:focus-within': {
			  outline: 'none',
			  backgroundColor: 'transparent',
			},
			'& .MuiDataGrid-cell:active': {
			  backgroundColor: 'transparent',
			},
			'& .MuiDataGrid-cell.Mui-focusVisible': {
			  backgroundColor: 'transparent',
			},

			}}
      />
	  )}
	</div>
  );
}
